module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/figiii-01.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "book-title"
  }, [_vm._v("SEAL WARRIOR")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("Death in the Dark: Vietnam 1968–1972")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Thomas H. Keith"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('em', [_vm._v("Master Chief, SEAL Team 2, USN (Ret.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_vm._v("and J. Terry Riebling")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Foreword by Michael E. Thornton,"), _c('br'), _c('em', [_vm._v("Lt., USN (Ret.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THOMAS DUNNE BOOKS   "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/publisher.jpg"
    }
  }), _vm._v("   ST. MARTIN’S PRESS NEW YORK")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-943463b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 63
// module chunks = 0